/* unplugin-vue-components disabled */import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "errPage-container"
};
const _hoisted_2 = {
  class: "list-unstyled"
};
const _hoisted_3 = {
  class: "link-type"
};
const _hoisted_4 = ["src"];
import errImage from "@/assets/401_images/401.gif";
export default {
  __name: '401',
  setup(__props) {
    let {
      proxy
    } = getCurrentInstance();
    const errGif = ref(errImage + "?" + +new Date());
    function back() {
      if (proxy.$route.query.noGoBack) {
        proxy.$router.push({
          path: "/"
        });
      } else {
        proxy.$router.go(-1);
      }
    }
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_button, {
        icon: "arrow-left",
        class: "pan-back-btn",
        onClick: back
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode(" 返回 ", -1)]))]),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_cache[2] || (_cache[2] = _createElementVNode("h1", {
            class: "text-jumbo text-ginormous"
          }, " 401错误! ", -1)), _cache[3] || (_cache[3] = _createElementVNode("h2", null, "您没有访问权限！", -1)), _cache[4] || (_cache[4] = _createElementVNode("h6", null, "对不起，您没有访问权限，请不要进行非法操作！您可以返回主页面", -1)), _createElementVNode("ul", _hoisted_2, [_createElementVNode("li", _hoisted_3, [_createVNode(_component_router_link, {
            to: "/"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode(" 回首页 ", -1)]))]),
            _: 1
          })])])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("img", {
            src: _unref(errGif),
            width: "313",
            height: "428",
            alt: "Girl has dropped her ice cream."
          }, null, 8, _hoisted_4)]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
};